import generateEnvironment from '../../utils/generateEnvironment'

const environment = (accessToken) => {
  return generateEnvironment(process.env.REACT_APP_API_URL, accessToken)
}

export default environment
